<script setup lang="ts">
import { inject, type Ref } from 'vue'
import type { ContainerAction } from '@/actions/ContainerMove'

defineEmits(['action-selected'])

const action = inject('action') as Ref<ContainerAction | null>
</script>

<template>
  <div class="actions">
    <button
      type="button"
      :class="{ action: true, pull: true, active: action === 'PULL' }"
      @click="$emit('action-selected', 'PULL')"
    >
      <img src="../assets/pull-container.svg" /><span>Retirer</span></button
    ><button
      type="button"
      :class="{ action: true, drop: true, active: action === 'DROP' }"
      class="action drop"
      @click="$emit('action-selected', 'DROP')"
    >
      <img src="../assets/drop-container.svg" /><span>Déposer</span></button
    ><button
      type="button"
      :class="{ action: true, empty: true, active: action === 'EMPTY' }"
      @click="$emit('action-selected', 'EMPTY')"
    >
      <img src="../assets/empty-container.svg" /><span>Bac vide</span>
    </button>
  </div>
</template>

<style scoped lang="scss">
.actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin: 2dvh 0;

  .action {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    background: none;
    border: 5px solid transparent;
    border-radius: 5px;
    outline: none;
    padding-top: 0.7dvh;
    padding-bottom: 0.3dvh;
    width: 30%;
    transition: border 0.35s ease-in-out;

    &.active {
      border-color: #ffbd00;
    }

    &.pull {
      color: #1611e5;
    }

    &.drop {
      color: #79c944;
    }

    &.empty {
      color: #d20000;
    }

    & > img {
      height: 8dvh;
      margin-left: -5px;
    }

    & > span {
      margin-top: 1dvh;
      text-transform: uppercase;
      font-size: 14px;
      font-weight: 600;
    }
  }
}
</style>
